import { DefaultCell, DefaultCellRightAlign } from "app/components/React/Table/cells";
import { IntentCell } from "app/components/React/Table/cells/IntentCell";
import { DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { translate } from "app/filters/i18nFilter";
import { EColumnsFields } from "app/common/campaigns/KeywordsCampaginKeywordsTableConsts";
import { RTEnrichButtonCell, TargetUrlCell } from "app/pages/digital-marketing/keywords-campaigns/shared/components";

import { EnrichAmountUrlWrapper } from "./KeywordsReportStyledComponents";

export const lastUpdatedTableColumns = {
    field: EColumnsFields.LAST_UPDATED,
    sortable: true,
    cellComponent: DefaultCell,
    get displayName() {
        return translate("seo.keywordsCampaign.keywordsReport.table.column.updated");
    },
    get tooltip() {
        return translate("seo.keywordsCampaign.keywordsReport.table.column.updated.tooltip");
    },
    get title() {
        return translate("rankTracker.keywordsReport.table.column.updated.dashboard.title");
    }, //required for dashboard
    minWidth: 140,
    sortDirection: "desc",
    visible: false,
};

export const intentTableColumns = {
    field: EColumnsFields.INTENT,
    cellComponent: IntentCell,
    get displayName() {
        return translate("seo.keywordsCampaign.keywordsReport.table.column.intent.title");
    },
    get tooltip() {
        return translate("seo.keywordsCampaign.keywordsReport.table.column.intent.tooltip");
    },
    get title() {
        return translate("rankTracker.keywordsReport.table.column.intent.dashboard.title");
    }, //required for dashboard
    minWidth: 130,
};

export const cpcTableColumns = {
    field: EColumnsFields.CPC,
    sortable: true,
    headerComponent: DefaultCellHeaderRightAlign,
    cellComponent: DefaultCellRightAlign,
    get displayName() {
        return translate("analysis.source.search.all.table.columns.cpc.title");
    },
    get tooltip() {
        return translate("analysis.source.search.all.table.columns.cpc.title.tooltip");
    },
    get title() {
        return translate("rankTracker.keywordsReport.table.column.cpc.dashboard.title");
    }, //required for dashboard
    minWidth: 80,
    sortDirection: "desc",
    visible: false,
};

const urlAmountButton = (amountOfAdditionalSites: number) => {
    const enrichButtonText = isNaN(amountOfAdditionalSites) ? 0 : amountOfAdditionalSites + 1;
    return <EnrichAmountUrlWrapper>{`${enrichButtonText}`}</EnrichAmountUrlWrapper>;
};

export const urlAmountTableColumns = {
    field: EColumnsFields.NUMBER_OF_URLS,
    headerComponent: DefaultCellHeaderRightAlign,
    sortable: true,
    sortDirection: "desc",
    cellComponent: (props) => {
        const { row, value } = props;
        const { amountOfAdditionalSites } = value;
        const buttonText = urlAmountButton(amountOfAdditionalSites);
        const cellTooltipText = translate("rankTracker.keywordsReport.numUrls.cell.tooltip");
        return (
            <RTEnrichButtonCell
                {...props}
                buttonElement={buttonText}
                enabledTooltip={!row.Keywords?.length}
                markOnHoverOnRow={false}
                presentEnrichButton={true}
                tooltipText={cellTooltipText}
                isButtonLeftSide={true}
            />
        );
    },
    get displayName() {
        return translate("rankTracker.keywordsReport.numUrls.title");
    },
    get tooltip() {
        return translate("seo.keywordsCampaign.keywordsReport.keywordsTable.topURL.tooltip");
    },
    get title() {
        return translate("rankTracker.keywordsReport.numUrls.title");
    }, //required for dashboard
    width: 80,
};

export const topUrlTableColumns = (onTargetUrlClick, isSelectable: boolean) => {
    return {
        field: EColumnsFields.TARGET_URL,
        cellComponent: (props) => {
            const { value, row } = props;
            const { site } = value;
            const { targetUrls } = row;

            return (
                <TargetUrlCell
                    site={site}
                    targetUrls={targetUrls}
                    onClick={() => onTargetUrlClick(row)}
                    isButtonDisabled={!isSelectable}
                />
            );
        },
        get displayName() {
            return translate("seo.keywordsCampaign.keywordsReport.table.column.urlOrganics.title");
        },
        get tooltip() {
            return translate("seo.keywordsCampaign.keywordsReport.table.column.urlOrganics.title.tooltip");
        },
        get title() {
            return translate("rankTracker.keywordsReport.table.column.topURL.dashboard.title");
        }, //required for dashboard
        minWidth: 250,
        cellClass: "cell-without-padding",
        cellCls: "cell-without-padding", //required for dashboard
    };
};
